import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Field } from '@oneform/react';
import { memo, useCallback, } from 'react';
const MintedField = (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
fieldProps) => {
    const translateProps = (useCallback(({ errorMessages, fieldName, isChecked, isVisited, updateFieldValue, value, visitField, }) => ({
        checked: isChecked,
        error: (typeof errorMessages[0] === 'string'
            ? errorMessages[0]
            : (errorMessages[0]
                ? ' '
                : '')),
        name: fieldName,
        onBlur: visitField,
        onChange: updateFieldValue,
        touched: isVisited,
        value,
    }), []));
    return (_jsx(Field, Object.assign({}, fieldProps, { translateProps: translateProps })));
};
const MemoizedMintedField = memo(MintedField);
export { MemoizedMintedField as MintedField };
